import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { authClient } from "@/lib/auth";
import { useSessionQuery } from "@/queries/queries";

// Shows a banner while an admin is impersonating another user. Better Auth sets
// `session.impersonatedBy` on the impersonation session.
export function ImpersonationBanner() {
    const { data } = useSessionQuery();
    const [stopping, setStopping] = useState(false);

    const impersonatedBy = data?.session?.impersonatedBy;
    if (!impersonatedBy) return null;

    const handleStop = async () => {
        setStopping(true);
        const { error } = await authClient.admin.stopImpersonating();
        if (error) {
            toast.error(error.message ?? "Failed to stop impersonating");
            setStopping(false);
            return;
        }
        // Back to the admin's own session.
        window.location.assign("/admin/users");
    };

    return (
        <div className="fixed inset-x-0 top-0 z-1000 flex items-center justify-center gap-3 bg-amber-500 px-4 py-1.5 text-sm font-medium text-amber-950 shadow">
            <span>
                You are impersonating <strong>{data?.user?.email}</strong>
            </span>
            <Button
                size="sm"
                variant="outline"
                className="h-6 border-amber-900/30 bg-white/80 px-2 py-0 text-xs hover:bg-white"
                disabled={stopping}
                onClick={handleStop}
            >
                {stopping ? "Stopping…" : "Stop impersonating"}
            </Button>
        </div>
    );
}
